/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 04/07/2026.
 */

import React from 'react'
import { DisconnectOutlined } from '@ant-design/icons'
import { COLOR } from '../../constants'

type QuestionHeaderProps = {
  title: string
  body: string
  isAnswered: boolean
  isOffline?: boolean
}

//
// Used for both the dependency and the Ordered assignment view
//
export const QuestionHeader = ({ title, body, isAnswered, isOffline = false }: QuestionHeaderProps) => {
  return (
    <div className="col-12 ">
      <div className="d-flex justify-content-between">
        <h5>{title}</h5>

        {!isAnswered && !isOffline ? (
          <div className="">
            <p className="p-mini  px-2 rounded-pill text-white " style={{ background: COLOR.DARK_GRAY }}>
              Missed
            </p>
          </div>
        ) : null}

        {isOffline && isAnswered ? (
          <span className="p-mini opacity-50" style={{ display: 'block', marginBottom: '3px' }}>
            Offline <DisconnectOutlined />
          </span>
        ) : null}
      </div>
      <p>{body}</p>
    </div>
  )
}
